/**
 * Resolve logo URL for light/dark + white-label.
 * Priority: org dark logo (dark) → org logo → Coursolo white (dark) → Coursolo color (light)
 */
export const COURSOLO_LOGO_LIGHT = '/logo512.png';
export const COURSOLO_LOGO_DARK = '/coursolo-logo-white--v1.png';

export function isDocumentDark() {
    if (typeof document === 'undefined') return false;
    return document.documentElement.classList.contains('dark');
}

export function getBrandLogoSrc(branding, { dark } = {}) {
    const isDark = dark == null ? isDocumentDark() : Boolean(dark);
    const logoUrl = String(branding?.logoUrl || '').trim();
    const logoDarkUrl = String(branding?.logoDarkUrl || '').trim();

    if (isDark && logoDarkUrl) return logoDarkUrl;
    if (logoUrl) return logoUrl;
    return isDark ? COURSOLO_LOGO_DARK : COURSOLO_LOGO_LIGHT;
}

/** True when org uploaded its own logo (may be icon-only). Default Coursolo asset already includes the wordmark. */
export function hasCustomBrandLogo(branding) {
    return Boolean(String(branding?.logoUrl || '').trim() || String(branding?.logoDarkUrl || '').trim());
}

/** Default platform names already appear inside the Coursolo wordmark logo. */
export function isCoursoloBrandName(name) {
    const n = String(name || '')
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '');
    return !n || n === 'coursolo' || n === 'coursolo.ai' || n === 'coursoloai';
}

/**
 * Show a text name beside/under the logo only for white-label orgs with a distinct name.
 * Never repeat "Coursolo.ai" when a logo is already on screen.
 */
export function shouldShowBrandNameWithLogo(branding, name) {
    if (isCoursoloBrandName(name)) return false;
    return hasCustomBrandLogo(branding);
}

export function getBrandFallbackSrc({ dark } = {}) {
    const isDark = dark == null ? isDocumentDark() : Boolean(dark);
    return isDark ? COURSOLO_LOGO_DARK : COURSOLO_LOGO_LIGHT;
}
